import React from 'react'
import { useInviteUserMutation } from '../../../../../store/apis/user.api'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import UserForm from '../UserForm'
import { useFetchOrganizationsQuery } from '../../../../../store/apis/organization.api'
import { UserRoles } from '../../../../../constants'
import { UserTypes } from '../../../../../constants/UserRoles'
import useAuthorization from '../../../../../components/authorization/useAuthorization'

const InviteUserForm = ({ onSuccess }) => {
    const [inviteUser, inviteUserResult] = useInviteUserMutation()
    const { isAuthorized: isSystemAdmin } = useAuthorization([UserRoles.ADMIN], [UserTypes.SYSTEM_ADMIN])
    const { data: organizations, isFetching: isFetchingOrganizations } = useFetchOrganizationsQuery(null, { skip: !isSystemAdmin })

    const handleInviteUser = async values => {
        const response = await inviteUser(values)

        if ('data' in response) {
            openNotificationWithIcon('success', `User was invited successfully. An email has been sent to <code>${values.email}</code> with instructions to set up their account.`)
            onSuccess && onSuccess()
        }
    }

    return (
        <UserForm
            organizations={organizations}
            isFetchingOrganizations={isFetchingOrganizations}
            onSubmit={handleInviteUser}
            loading={inviteUserResult.isLoading}
            error={inviteUserResult.error}
            fieldsToHide={['status', 'password', 'name']}
            actionName='Invite'
        />
    )
}

export default InviteUserForm
